import React from 'react';
import { RouteObject } from 'react-router-dom';

import { UserRole } from '@/shared/enums/user-role.enum';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const PartnerConfigContainer = React.lazy(
  () => import('../../containers/partner-config/partner-config.container')
);

export const PartnerConfigRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={PartnerConfigContainer}
        />
      </React.Suspense>
    )
  }
];
